
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import Constants from "../../utilities/js/Constants";
import BracketList from "components/reusable/BracketList";
import { showErrorToast } from "utilities/js/ToastHelper";
import { getAccountInfo, createFollow, removeFollow, getFollow } from "utilities/js/callouts/CalloutFactory";
import getTimeSince from "utilities/js/TimeManager";
import LoadingWall from "components/reusable/LoadingWall";
import { navigateToLandingPage } from "utilities/js/NavigationHelper";
import { useEffect, useState } from "react";

const AccountPageContent = props => {

    const queryClient = useQueryClient();
    const navigate = useNavigate();

    const [disabledFollowButton, setDisabledFollowButton] = useState(false);

    const accountResponse = useQuery({
        queryKey: ['accountPage', props.accountId],
        queryFn: () => {return getAccountInfo({accountId: props.accountId})},
        staleTime: Infinity,
        enabled: !!props.accountId        
    })
    if(accountResponse.isError){
        console.log('error found!');
        navigateToLandingPage({routerNav: navigate});
    }
    
    const followResponse = useQuery({
        queryKey: ['isFollowing', props.accountId],
        queryFn: () => {return getFollow({accountId: props.accountId})},
        staleTime: Infinity,
        enabled: !!props.accountId,
        retry: false
    })


    async function follow(){
        setDisabledFollowButton(true);

        createFollow({accountId: props.accountId}).then((response) => {
            //Possible statuses: complete, requested
            queryClient.invalidateQueries({ queryKey: ['isFollowing', props.accountId] })

        }).catch(error => {
            // showErrorToast(this, 'Your request cannot be processed at this time');
            console.log('unable to complete follow request');
        }).finally(() => {
            setTimeout(() => {
                setDisabledFollowButton(false);
            }, 1000)
        })
    }

    async function unfollow(){
        
        setDisabledFollowButton(true);
        removeFollow({accountId: props.accountId}).then((response) => {
            // setFollowStatus(response.status.toLowerCase());
            queryClient.invalidateQueries({ queryKey: ['isFollowing', props.accountId] })
        }).catch(error => {
            // showErrorToast(this, 'Your request cannot be processed at this time');
            console.log('unable to complete unfollow request');
        }).finally(() => {
            setTimeout(() => {
                setDisabledFollowButton(false);
            }, 1000)
        })
    }

    function displayFollowButton(){
        if(followResponse.data){
            if(!followResponse.data.status){
                if(followResponse.data.isPrivate){
                    if(disabledFollowButton){
                        return (<button label='follow-button' className='nav-button' disabled>Request Follow</button>)
                    }else{
                        return (<button label='follow-button' className='nav-button' onClick={follow}>Request Follow</button>)
                    }
                }else{
                    if(disabledFollowButton){
                        return (<button label='follow-button' className='nav-button' disabled>Follow</button>)
                    }else{
                        return (<button label='follow-button' className='nav-button' onClick={follow}>Follow</button>)
                    }
                }
            }else if(followResponse.data.status === 'complete'){
                if(disabledFollowButton){
                    return (<button label='unfollow-button' className='nav-button-green' disabled>Following</button>)
                }else{
                    return (<button label='unfollow-button' className='nav-button-green' onClick={unfollow}>Following</button>)
                }
            }else if(followResponse.data.status === 'requested'){
                if(disabledFollowButton){
                    return (<button label='follow-requested-button' className='nav-button-dark' disabled>Requested</button>)
                }else{
                    return (<button label='follow-requested-button' className='nav-button-dark' onClick={unfollow}>Requested</button>)
                }
            }
        }
    }

    if(accountResponse.isSuccess){
        return (
            <>
                <div className="nav-panel">
                    <div className="account-info-header">

                        <div className="account-info-main">

                            <div className="account-header-icon">
                                <div className="account-icon-indicator" style={{ backgroundColor: accountResponse.data.color }}>
                                    {accountResponse.data.username.substring(0, 1)}
                                </div>
                            </div>
                            <div className="account-info-header-text">
                                <div className="account-info-username">
                                    @{accountResponse.data.username}
                                </div>
                                <div className="account-info-subtitle">
                                    Joined {getTimeSince(new Date(parseInt(accountResponse.data.created_date)))}
                                </div>
                            </div>

                        </div>


                        <div className="account-info-header-actions">
                            {displayFollowButton()}
                        </div>
                    </div>
                </div>

                <div className="brackset-list-header">
                    <div className="brackset-list-header-text">
                        @{accountResponse.data.username}'s Brackets
                    </div>
                </div>
                <div className="nav-panel">
                    <BracketList createdBy={props.accountId} variant="detail"></BracketList>
                </div>
            </>
        )
    }else if(accountResponse.isFetching){
        return (<LoadingWall isLoading={accountResponse.isFetching}></LoadingWall>)
    }
}

export default AccountPageContent;